import { initSiteHeader } from '../ui/siteHeader.js';

initSiteHeader();

// ── Allers-retours texte <-> notes ───────────────────────────────────────
// Pas de saut d'ancre natif (#note-4) : sur iPhone, Safari faisait défiler
// plus que la zone de texte et sortait le header et le footer de l'écran
// (constaté par Rudy, 11 octobre 2026, malgré le correctif CSS iOS). On
// fait défiler nous-mêmes uniquement le conteneur qui défile vraiment.
const SCROLL_GAP_PX = 24; // air sous le header collant

function scrollContainerOf(el) {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node);
    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
  }
  return document.scrollingElement || document.documentElement;
}

function scrollToTarget(target) {
  const scroller = scrollContainerOf(target);
  const headerHeight = document.querySelector('header')?.getBoundingClientRect().height || 0;
  const scrollerTop = scroller === document.scrollingElement ? 0 : scroller.getBoundingClientRect().top;
  const top = target.getBoundingClientRect().top - scrollerTop + scroller.scrollTop - headerHeight - SCROLL_GAP_PX;
  scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

document.querySelector('.notice')?.addEventListener('click', (event) => {
  const link = event.target.closest('.notice-ref a, .notice-note-back');
  if (!link) return;
  const target = document.getElementById(link.getAttribute('href').slice(1));
  if (!target) return;
  event.preventDefault();
  scrollToTarget(target);
});
